module.exports = __webpack_public_path__ + "static/icons/icon-legend-swell-arrow-72bb3fff36b245384d88cef1ae4a800f.svg";